import styled from "styled-components"
import {useState} from "react"
import {HashLink} from 'react-router-hash-link'
import ModalDownloadApp from "../MobileApp/components/ModalDownloadApp"

const Footer = () => {

	const [selectedStore, setSelectedStore] = useState(null)

	return (
		<Wrapper>
			<Content>
				<TopLine>
					<Company>
						<h2>АТС24</h2>
						<Contacts>
							<div>Москва, 2-й Рощинский проезд, дом 8</div>
							<div>+7 (495) 212-91-55</div>
							<div><a href="mailto:inbox@ats24.ru">inbox@ats24.ru</a></div>
						</Contacts>
					</Company>
					<Navigation>
						<NavigationColumn>
							<NavigationTitle>Маршрутизация</NavigationTitle>
							<HashLink to="/routing#map">Совместная работа</HashLink>
							<HashLink to="/routing#metrics">Автомат</HashLink>
							<HashLink to="/routing#geocode">Ручной режим</HashLink>
							<HashLink to="/routing#schedule">Преимущества</HashLink>
							<HashLink to="/routing#performance">Перенос точек</HashLink>
							<HashLink to="/routing#group-use">Печать документов</HashLink>
							<HashLink to="/routing#group-use">Выбор ворот</HashLink>
						</NavigationColumn>
						<NavigationColumn>
							<NavigationTitle>Мониторинг</NavigationTitle>
							<HashLink to="/monitoring#logs">Доставки</HashLink>
							<HashLink to="/monitoring#divisions">Статус посещений</HashLink>
							<HashLink to="/monitoring#fuel-sensor">Журнал событий</HashLink>
							<HashLink to="/monitoring#archive">Оперативный отчёт</HashLink>
							<HashLink to="/monitoring#temp-sensor">Филиалы</HashLink>
							<HashLink to="/monitoring#door-sensor">Транспорт</HashLink>
							<HashLink to="/monitoring#door-sensor">Трекбар</HashLink>
							<HashLink to="/monitoring#door-sensor">Водители</HashLink>
							<HashLink to="/monitoring#door-sensor">События</HashLink>
						</NavigationColumn>
						<NavigationColumn>
							<NavigationTitle>Приложение</NavigationTitle>
							<HashLink to="/mobile-app#route">Маршрутный лист</HashLink>
							<HashLink to="/mobile-app#points-info">Информация о точках</HashLink>
							<HashLink to="/mobile-app#invoices">Электронные накладные</HashLink>
							<HashLink to="/mobile-app#check-lists">Дополнительные опции</HashLink>
							<HashLink to="/mobile-app#photo-fixation">Автоматические статусы</HashLink>
							<HashLink to="/mobile-app#barcode-scanner">Календарь</HashLink>
							<HashLink to="/mobile-app#government-fines">Штрафы ГИБДД</HashLink>
							<HashLink to="/mobile-app#job-calendar">Тёмная тема</HashLink>
						</NavigationColumn>
						<NavigationColumn>
							<NavigationTitle>Сервисы</NavigationTitle>
							<a href="/services/reports">Отчёты</a>
							<a href="/services/fines">Мотивация водителей</a>
							<a href="/services/motivation">Штрафы ГИБДД</a>
							<a href="/services/telegram">Телеграм бот</a>
							<NavigationTitle style={{marginTop: '1.5rem'}}>Дополнительно</NavigationTitle>
							<HashLink to="/price">Тарифы</HashLink>
							<HashLink to="/contacts">Контакты</HashLink>
						</NavigationColumn>
					</Navigation>
				</TopLine>
				<BottomLine>
					<Buttons>
						<SocialsButtons>
							<a href="https://t.me/ats24ru" target="_blank">
								<img src="/assets/img/svg/telegram.svg" width={36}/>
							</a>
							<a href="https://wa.me/+79057774237" target="_blank">
								<img src="/assets/img/svg/whatsapp.svg" width={36}/>
							</a>
						</SocialsButtons>
						<StoreButtons>
							<StoreButton onClick={() => setSelectedStore('google-play')} store="google-play"/>
							<StoreButton onClick={() => setSelectedStore('app-store')} store="app-store"/>
							<StoreButton onClick={() => setSelectedStore('app-gallery')} store="app-gallery"/>
						</StoreButtons>
					</Buttons>
				</BottomLine>
			</Content>
			<ModalDownloadApp setSelectedStore={setSelectedStore} selectedStore={selectedStore}/>
		</Wrapper>
	)
}

export default Footer

const Wrapper = styled.footer`
    display: flex;
    width: 100%;
    justify-content: center;
`
const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 1320px;
    padding: 6.66rem 1.5rem;
    gap: 1.2rem;
    border-top: solid 1px #eeeeee;

    @media (max-width: 920px) {
        padding: 6.66rem 0.75rem;
    }
`

const TopLine = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 4rem;

    @media (max-width: 1200px) {
        flex-wrap: wrap;
        flex-direction: column;
    }
`

const Company = styled.div`
    display: flex;
    flex-direction: column;
    width: 300px;
    flex-shrink: 0;

    @media (max-width: 1200px) {
        width: 100%;
    }
`

const Contacts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-top: 1.2rem;
    opacity: .7;
`

const Navigation = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
    width: 100%;

    @media (max-width: 920px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 460px) {
        grid-template-columns: 1fr;
    }
`

const NavigationColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
`
const NavigationTitle = styled.div`
    text-transform: uppercase;
    opacity: .7;
`
const BottomLine = styled.div`
    display: flex;
    align-items: flex-start;
`
const Buttons = styled.div`
    display: flex;
    flex: 1;
    align-items: flex-start;
    padding-top: 2.22rem;
    gap: 1.2rem;
`

const SocialsButtons = styled.div`
    display: flex;
    flex: 1;
    gap: 0.55rem;
`
const StoreButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.55rem;
`
const StoreButton = styled.div`
    width: 6.77rem;
    height: 2rem;
    background-image: url(${props => "/assets/img/png/mobile-app/" + props.store + ".png"});
    background-size: 100% auto;
    transition: opacity .3s;
    cursor: pointer;

    :hover {
        opacity: .7;
    }
`